import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { PrivateRoutes } from '../../../main/constant/RouteConstant';
import { AddPatientPageStyled } from '../addPatient/AddPatientPageStyled';
import { Button, Card, Col, Container, Form, Row, InputGroup } from 'react-bootstrap';
import ContainerSideBarComponent from '../../component/container/ContainerSidebarComponent';
import { TfiSave } from 'react-icons/tfi';
import { FaArrowLeft } from 'react-icons/fa';
import { PiIdentificationCard } from 'react-icons/pi';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai'; // Ícones de olho
import AlertComponent from '../../component/alert/AlertComponent';
import { UseAuth } from '../../hook/AuthHook';
import MessageConstant from '../../../main/constant/MessageConstant';

interface InputsForgotPassword {
  login: string;
  oldPassword: string;
  newPassword: string;
  confirmPassword: string;
}

type Props = {
  sendPassword: (params: { login: string; oldPassword: string; newPassword: string; confirmPassword: string }) => Promise<any>;
};

const ChangePasswordPage: React.FC<Props> = ({ sendPassword }: Props) => {
  let navigate = useNavigate();
  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm<InputsForgotPassword>();

  const [showNewPassword, setShowNewPassword] = useState(false); // Controle de visibilidade da nova senha
  const [showConfirmPassword, setShowConfirmPassword] = useState(false); // Controle de visibilidade da confirmação da senha

  const handleVoltar = async () => {
    navigate(PrivateRoutes.HOME);
  };

  const handleSend = async () => {
    const model = {
      login: user.login,
      oldPassword: getValues('oldPassword'),
      newPassword: getValues('newPassword'),
      confirmPassword: getValues('confirmPassword'),
    };
    await sendPassword(model);
  };

  const handleSubmitValidation = async () => {
    await handleSend();
  };

  const { loggedUserData } = UseAuth();

  const [user, setUser] = useState<any>({
    id: 0,
    name: '',
    login: '',
  });

  useEffect(() => {
    if (loggedUserData !== undefined) {
      setUser(loggedUserData);
    }
  }, [loggedUserData]);

  return (
    <ContainerSideBarComponent>
      <AlertComponent />
      <AddPatientPageStyled>
        <Container fluid className="title-page">
          <h3>Trocar Senha</h3>
        </Container>

        <Container fluid>
          <Card>
            <Card.Body>
              <Container fluid>
                <Form onSubmit={handleSubmit(handleSubmitValidation)}>
                  <div className="container-field">
                    <Row className="row-field">
                      <Col>
                        <Button size="sm" style={{ float: 'right' }} type={'submit'}>
                          <TfiSave width={30} style={{ paddingRight: '5px' }} />
                          Salvar
                        </Button>
                        <Button size="sm" variant="outline-primary" style={{ float: 'right', marginRight: '5px' }} onClick={handleVoltar}>
                          <FaArrowLeft width={30} style={{ paddingRight: '5px' }} />
                          Voltar
                        </Button>
                      </Col>
                    </Row>
                    <div className="title">
                      <PiIdentificationCard />
                      <h6>Dados</h6>
                    </div>

                    <Row className="row-field">
                      <Col>
                        <Form.Label>Login</Form.Label>
                        <Form.Control placeholder="Login" value={user.login} disabled={true} {...register('login')} />
                      </Col>
                    </Row>

                    <Row className="row-field">
                      <Col>
                        <Form.Label>Senha atual</Form.Label>
                        <Form.Control
                          type="password"
                          placeholder="Senha atual"
                          {...register('oldPassword', { required: MessageConstant.validacao.campoObrigatorio })}
                        />
                        {errors.oldPassword && <span className="text-danger">{errors.oldPassword.message}</span>}
                      </Col>
                    </Row>

                    <Row className="row-field">
                      <Col>
                        <Form.Label>Nova senha</Form.Label>
                        <InputGroup>
                          <Form.Control
                            type={showNewPassword ? 'text' : 'password'}
                            placeholder="Nova senha"
                            {...register('newPassword', { required: MessageConstant.validacao.campoObrigatorio })}
                          />
                          <InputGroup.Text onClick={() => setShowNewPassword(!showNewPassword)}>
                            {showNewPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
                          </InputGroup.Text>
                        </InputGroup>
                        {errors.newPassword && <span className="text-danger">{errors.newPassword.message}</span>}
                      </Col>
                    </Row>

                    <Row className="row-field">
                      <Col>
                        <Form.Label>Confirme nova senha</Form.Label>
                        <InputGroup>
                          <Form.Control
                            type={showConfirmPassword ? 'text' : 'password'}
                            placeholder="Confirme nova senha"
                            {...register('confirmPassword', { required: MessageConstant.validacao.campoObrigatorio })}
                          />
                          <InputGroup.Text onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                            {showConfirmPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
                          </InputGroup.Text>
                        </InputGroup>
                        {errors.confirmPassword && <span className="text-danger">{errors.confirmPassword.message}</span>}
                      </Col>
                    </Row>
                  </div>
                </Form>
              </Container>
            </Card.Body>
          </Card>
        </Container>
      </AddPatientPageStyled>
    </ContainerSideBarComponent>
  );
};

export default ChangePasswordPage;
